import React, { useEffect, useState } from "react";
import { HomeWrapper, TopBarWrapper } from "./StyledComponent";
import Header from "./Header";
import GovtStrip from "./GovtStrip";
import DepartmentPanel from "./DepartmentPanel";
import SlideShow from "./SlideWrapper";
import FastPasPanel from "./FastPasText";
import LinksSlideshow from "../TCP-HP/LinksSlideShow";
import ContactSection from "./ContactSection";
import FastPasInfoSection from "./FastPasPanel";
import ProcedureCards from "./InfoCards";
import FastPasFooter from "./Footer/FastPasFooter";
import AboveFooter from "./AboveFooter";
import { useHistory, useLocation } from "react-router-dom";
import AboveFooterNew from "./AboveFooter/AboveFooter";
import InfoCards from "./InfoCards/InfoCards";
import DuePayment from "../../../actionView/DuePayment";
// import { bannerImgUrls } from './data'
// import ImageSlideshow from './SlideWrapper/ImagesSlideShow'
// import Slider from './CustomSlideShow'
// import ScrollButton from './UpwardScrollButton'

function AwasBandhu({ setApplicationFlow }) {
  const location = useLocation();
  const history = useHistory();
  const [showDuePaymentGroup, setShowDuePaymentGroup] = useState(false);
  const homepath = location?.pathname?.includes("digit-ui/citizen");

  // Redirect already-logged-in users away from the home/login page.
  // Using history.replace() so the login page is removed from the browser
  // history stack — back button will NOT bring the user back here.
  useEffect(() => {
    const user = Digit.UserService.getUser();
    const isLoggedIn = user && user.access_token && user.info;
    if (isLoggedIn) {
      const isEmployee = user.info.type === "EMPLOYEE";
      const redirectPath = isEmployee
        ? "/digit-ui/employee"
        : "/digit-ui/citizen/profile";
      history.replace(redirectPath);
    }
  }, []);
  return (
    <HomeWrapper>
      {/* style={{ marginTop: homepath ? '-80px' : '0px' }} */}
      <TopBarWrapper>
        <Header />
        <GovtStrip style={{ padding: "0.1rem" }} />
        <DepartmentPanel setApplicationFlow={setApplicationFlow} setShowDuePaymentGroup={setShowDuePaymentGroup} />
      </TopBarWrapper>
      {showDuePaymentGroup && <DuePayment setShowDuePaymentGroup={setShowDuePaymentGroup} />}
      {/* Conditionally render the group */}
      {!showDuePaymentGroup && (
        <div>
          <SlideShow />
          <AboveFooterNew />
          <FastPasFooter />
        </div>
      )}
      {/* <SlideShow />
      <AboveFooterNew />
      <FastPasFooter /> */}
      {/* <ImageSlideshow images={bannerImgUrls}/> */}
      {/* <Slider/> */}
      {/* <FastPasPanel />
			<FastPasInfoSection /> */}
      {/* <ProcedureCards /> */}
      {/* <InfoCards/> */}
      {/* <LinksSlideshow
				titleStyles={{
					textTransform: 'uppercase',
					fontSize: '1.25rem',
					color: '#0E7693',
					fontWeight: 600,
				}}
				containerStyles={{ maxWidth: 1200 - 48, marginInline: 'auto' }}
			/> */}
      {/* <ContactSection /> */}
      {/* <AboveFooter /> */}
      {/* <ScrollButton/> */}
    </HomeWrapper>
  );
}

export default AwasBandhu;
